<template>

    <div class='container'>
        <center>
            <h2 class='title is-3'>Knowledge Center</h2>
            <h3 class='subtitle is-5'>Need help? Select a category below</h3>
            <br/>
        </center>

        <div class='columns'>
            <div class='column'>
                <div class="card" style='border-top-color: #f9a228'>
                  <div class="card-content">
                    <div class="content">
                        <b-icon icon="account" size="is-large" custom-class="orange"></b-icon>
                        <h4 class='title is-5'>Account</h4>
                        <!-- <h6 class='subtitle is-6'>Create account, explore site, interact with projects</h6> -->
                    </div>
                  </div>
                </div>
            </div>
            <div class='column'>
                <div class="card" style='border-top-color: #40a4d8'>
                  <div class="card-content">
                    <div class="content">
                        <b-icon icon="newspaper" size="is-large" custom-class="blue"></b-icon>
                        <h4 class='title is-5'>Projects</h4>
                        <p></p>
                    </div>
                  </div>
                </div>
            </div>
            <div class='column'>
                <div class="card" style='border-top-color: #a363d9'>
                  <div class="card-content">
                    <div class="content">
                        <b-icon icon="school" size="is-large" custom-class="purple"></b-icon>
                        <h4 class='title is-5'>University</h4>
                        <p></p>
                    </div>
                  </div>
                </div>
            </div>
            <div class='column'>
                <div class="card" style='border-top-color: #b2c225'>
                  <div class="card-content">
                    <div class="content">
                        <b-icon icon="cash" size="is-large" custom-class="green"></b-icon>
                        <h4 class='title is-5'>Crowdfunding</h4>
                        <p></p>
                    </div>
                  </div>
                </div>
            </div>
        </div>

        <div class='is-clearfix'></div>

        <section class="section">
            <div class="container content">
              <h1 class="title">Account</h1>
              <b-collapse :open="false" aria-id="contentIdForA11y1">
                <button
                    class="button is-primary"
                    slot="trigger"
                    aria-controls="contentIdForA11y1">Click me!</button>
                <div class="notification">
                    <div class="content">
                        <h3>
                            Subtitle
                        </h3>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                            Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. <br/>
                            Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.
                        </p>
                    </div>
                </div>
            </b-collapse>
              <ul>
                <li>a</li>
                <li>a</li>
                <li>a</li>
              </ul>

              <h1 class="title">Projects</h1>
              <ul>
                <li>a</li>
                <li>a</li>
                <li>a</li>
              </ul>

              <h1 class="title">University</h1>
              <ul>
                <li>a</li>
                <li>a</li>
                <li>a</li>
              </ul>

              <h1 class="title">Crowdfunding</h1>
              <ul>
                <li>a</li>
                <li>a</li>
                <li>a</li>
              </ul>
            </div>
        </section>
    </div>

</template>

<style scoped>
.card {
    text-align: center;
    border-top: 6px SOLID #000;
    min-height: 150px;
}
.card.orange { border-top-color: #f9a228; }
.card.purple { border-top-color: #40a4d8; }
.card.blue   { border-top-color: #a363d9; }
.card.green  { border-top-color: #b2c225; }
</style>

<script>
export default {
  name: 'Help',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Help.vue